import React from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';

import { t, translationsInterface } from '../../../../../utils/i18next';
import { spacingInRems } from '../../../../theme/themeUtils';
import * as PropTypes from 'prop-types';
import { GraphQLError } from 'graphql';

const StyledTypography = styled(Typography)`
  margin-top: ${spacingInRems()};
  flex-basis: 100%;
`;

const GeneralPaymentErrorText = props => {
  let isInPaymentInformation = false;
  if (typeof props.text === 'string') {
    isInPaymentInformation = translationsInterface.exists(
      `payment_flow.payment_information.${props.text}`
    );
  }
  return (
    <StyledTypography color={'error'} data-testid={'general-payment-error'}>
      {t(
        `payment_flow.payment_information.${
          isInPaymentInformation ? props.text : 'general_error'
        }`,
        {
          val: GeneralPaymentErrorText.phone
        }
      )}
    </StyledTypography>
  );
};

GeneralPaymentErrorText.phone = null;

export default GeneralPaymentErrorText;
GeneralPaymentErrorText.propTypes = {
  text: PropTypes.string
};
